<template>
  <div id="cards">
    <div @click="typeClick(card)" class="card-item" v-for="(card, i) in cards" :key="card.title">
      <div class="card-header">
        <div :class="[card.lineStatus == 3 ? 'card-header-right' : 'card-header-left']">{{ card.title }}
        </div>
        <div :class="'status status-' + card['lineStatus']" v-if="card.lineStatus != 3">
          <div class="status-text">
            {{
              card["lineStatus"] === 0
                ? "正常生产"
                : card["lineStatus"] === 1
                  ? "计划停机"
                  : card["lineStatus"] === 2
                    ? "非计划停机"
                    : ""
            }}
          </div>
        </div>
      </div>
      <div v-if="card.lineStatus == 3"
        style="text-align:center;width:100%;font-size:0.4rem;font-weight: bold;padding-top:20%;color:#6D6E6F">无生产计划
      </div>
      <dv-charts class="ring-charts" v-if="(card.lineStatus == 0 || card.lineStatus == 1 || card.lineStatus == 2)"
        :option="card.ring" />
    </div>
  </div>
</template>

<script>
export default {
  name: "oeecards",
  data() {
    return {
      cards: [],
      datas: this.beans,
    };
  },
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
  },
  methods: {
    decimal2(num) {
      // 先将数字乘以 10，使用 toFixed 方法将结果保留 0 位小数，再除以 10
      if (num == 0 || num == 100) {
        return num;
      }
      let result = parseFloat((num * 10).toFixed(0)) / 10;
      return result;
    },
    typeClick(data) {
      this.$router.push({
        path: "/oee/productLine",
        query: {
          uuid: data.uuid,
          title: data.title,
        },
      });
    },
    createData() {
      const { randomExtend } = this;
      var data = this.datas;
      var opts = [];
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var oeeValue = item["currentOEE"] || 0;
        var ftqValue = item["currentFTQ"] || 0;

        oeeValue = this.decimal2(oeeValue);
        ftqValue = this.decimal2(ftqValue);

        var oeeKpi = item["oeeKpi"];
        var ftqKpi = item["ftqKpi"];
        var lineStatus = item["lineStatus"];
        var statusText = item["lineStatus"] == 1 ? "停线" : "";
        var oeeColor = oeeValue >= oeeKpi ? "#00E690" : "red";
        var ftqColor = ftqValue >= ftqKpi ? "#00E690" : "red";

        var weekList = data[i]["weekList"];

        const xAxis = [];
        const barOee = [];
        const barFtq = [];
        const lineOee = [];
        const lineFtq = [];
        const colors = [];
        const colors2 = [];
        weekList.forEach((val) => {
          xAxis.push(val.week);
          barOee.push(this.decimal2(val.oee));
          barFtq.push(this.decimal2(val.ftq));

          lineOee.push(val.oeeKpi);
          lineFtq.push(val.ftqKpi);

          //颜色组
          colors.push(this.decimal2(val.oee) >= val.oeeKpi ? "#00E690" : "red");
          colors2.push(this.decimal2(val.ftq) >= val.ftqKpi ? "#00E690" : "red");
        });

        var opt = {};
        if (lineStatus != 3) { //无生产计划不显示数据
          opt = {
            title: item["line"],
            uuid: item["lineUUID"],
            lineStatus: lineStatus,
            statusText: statusText,
            total: {
              number: [randomExtend(9000, 10000)],
              content: "{nt}",
              textAlign: "right",
              style: {
                fill: "#ea6027",
                fontWeight: "bold",
              },
            },
            num: {
              number: [randomExtend(30, 60)],
              content: "{nt}",
              textAlign: "right",
              style: {
                fill: "#00E690",
                fontWeight: "bold",
              },
            },
            ring: {
              grid: {
                top: "70",
              },
              series: [
                {
                  type: "gauge",
                  dataItemStyle: {
                    fill: "#1ed3e5",
                    fontSize: 13,
                    textAlign: "right",
                  },
                  data: [
                    {
                      name: "OEE",
                      value: oeeValue,
                      gradient: [oeeColor],
                    },
                    {
                      name: "FTT",
                      value: ftqValue,
                      radius: "53%",
                      gradient: [ftqColor],
                    },
                  ],
                  arcLineWidth: 15,
                  center: ["50%", "55%"],
                  radius: "90%",
                  details: {
                    show: true,
                    formatter: "{name}\n{value}%",
                    valueToFixed: 1,
                    position: "start",
                    offset: [10, 5],
                    style: {
                      fontSize: 14,
                      fill: "#FFF",
                      textAlign: "left",
                    },
                  },
                  pointer: {
                    show: false,
                    valueIndex: 1,
                    style: {
                      scale: [1, 0.8],
                      fill: '#fff'
                    }
                  },
                  backgroundArc: {
                    show: true,
                    style: {
                      fill: "#0B2140",
                      stroke: "#0B2140",
                    },
                  },
                  dataItemStyle: {
                    lineCap: "round",
                    lineJoin: "round",
                  },
                  axisLabel: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                },
              ],
            },
            oee: {
              grid: {
                right: "15%",
                left: "18%",
                top: "18%",
                bottom: "20%",
              },
              title: {
                text: 'OEE',
                style: {
                  fill: "#fff",
                  fontSize: 14,
                },
                offset: [0, -12]
              },
              xAxis: {
                name: "WK", // 给X轴加单位
                nameLocation: "end",
                nameGap: 5,
                nameTextStyle: {
                  fill: '#fff',
                  fontSize: 11,
                },
                data: xAxis,
                axisLabel: {
                  style: {
                    fill: "#fff", // 坐标值得具体的颜色
                    fontSize: 11,
                  },
                },
                axisLine: {
                  show: true,
                  style: {
                    stroke: "#fff",
                  },
                },
                axisTick: {
                  style: {
                    stroke: "#fff", // 坐标值得具体的颜色
                  },
                },
              },
              yAxis: {
                name: "%",
                nameGap: 5,
                data: "value",
                nameTextStyle: {
                  fill: "#ffffff",
                  fontSize: 11,
                },
                label: {
                  show: true,
                  position: "inside",
                  style: {
                    fontSize: 11,
                  },
                  formatter: (params) => {
                    return params.value + "%";
                  },
                },
                axisLine: {
                  show: true,
                  style: {
                    stroke: "#fff",
                  },
                },
                axisTick: {
                  show: true,
                  style: {
                    stroke: "#fff",
                  },
                },
                axisLabel: {
                  show: true,
                  //  formatter: "{value}%",
                  style: {
                    fill: "#fff", // 坐标值得具体的颜色
                    fontSize: 11,
                  },
                },
                splitLine: {
                  show: true,
                  style: {
                    lineDash: [3, 3],
                  },
                },
                interval: 50,
                min: 0,
                max: 100,
              },
              series: [
                {
                  name: "OEE",
                  data: barOee,
                  label: {
                    show: true,
                    position: "center",
                    // offset: [0, -10],
                    style: {
                      fill: "#fff",
                      fontSize: 12,
                    },
                    //      formatter: "{value} %",
                  },
                  type: "bar",
                  barGap: "-100%",
                  barWidth: 18,
                  independentColor: true,
                  independentColors: colors,
                }
              ],
            },
            ftq: {
              grid: {
                right: "15%",
                left: "18%",
                top: "18%",
                bottom: "20%",
              },
              title: {
                text: 'FTT',
                style: {
                  fill: "#fff",
                  fontSize: 14,
                },
                offset: [0, -12]
              },
              xAxis: {
                name: "WK", // 给X轴加单位
                nameLocation: "end",
                nameGap: 5,
                nameTextStyle: {
                  fill: '#fff',
                  fontSize: 11,
                },
                data: xAxis,
                axisLabel: {
                  style: {
                    fill: "#fff", // 坐标值得具体的颜色
                    fontSize: 11,
                  },
                },
                axisLine: {
                  show: true,
                  style: {
                    stroke: "#fff",
                  },
                },
                axisTick: {
                  style: {
                    stroke: "#fff", // 坐标值得具体的颜色
                  },
                },
              },
              yAxis: {
                name: "%",
                nameGap: 5,
                data: "value",
                nameTextStyle: {
                  fill: "#ffffff",
                  fontSize: 11,
                },
                label: {
                  show: true,
                  position: "center",
                  style: {
                    fontSize: 11,
                  },
                  formatter: (params) => {
                    return params.value + "%";
                  },
                },
                axisLabel: {
                  show: true,
                  //  formatter: "{value}%",
                  style: {
                    fill: "#fff", // 坐标值得具体的颜色
                    fontSize: 11,
                  },
                },
                splitLine: {
                  show: true,
                  style: {
                    lineDash: [3, 3],
                  },
                },
                interval: 50,
                min: 0,
                max: 100,
                axisLine: {
                  show: true,
                  style: {
                    stroke: "#fff",
                  },
                },
                axisTick: {
                  show: true,
                  style: {
                    stroke: "#fff",
                  },
                },
              },

              series: [
                {
                  name: "FTT",
                  data: barFtq,
                  label: {
                    show: true,
                    position: "center",
                    // offset: [0, -10],
                    style: {
                      fill: "#fff",
                      fontSize: 12,
                    },
                    //  formatter: "{value} %",
                  },
                  type: "bar",
                  barWidth: 18,
                  independentColor: true,
                  independentColors: colors2,
                }
              ],
            },
          }
        } else {
          opt = {
            title: item["line"],
            uuid: item["lineUUID"],
            lineStatus: lineStatus,
            statusText: statusText,
            ring: {},
            oee: {},
            ftq: {}
          }
        }
        opts.push(opt);
      }
      this.cards = opts;
    },

    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10);
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      }
    },
  },
  mounted() {
    // const { createData } = this;
    //createData();
    // setInterval(this.createData, 30000);
  },
};
</script>

<style lang="less">
#cards {
  display: flex;
  //  justify-content: initial;
  height: 100%;

  .card-item {
    position: relative;
    margin: 0 .1rem 0 .1rem;
    // margin-right: 20px;
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, 0.5);
    width: 20%;
    display: flex;
    flex-direction: column;
  }

  .card-header {
    display: flex;
    height: 20%;
    align-items: center;
    justify-content: space-between;

    .card-header-left {
      position: absolute;
      top: 0.05rem;
      left: 0.05rem;
      //	width: 80%;
      text-align: left;
      font-size: 0.28rem;
      font-weight: bold;
      margin: 0 auto;
      //   padding-right: 1rem;
      text-shadow: 0 0 10px #fff, 0 0 25px #00bfff;
    }

    .card-header-right {
      position: absolute;
      top: 0.05rem;
      left: 0.05rem;
      //	width: 80%;
      text-align: left;
      font-size: 0.28rem;
      font-weight: bold;
      margin: 0 auto;
      color: #6D6E6F;
      text-shadow: 0 0 10px #6D6E6F, 0 0 25px #6D6E6F;
    }

    // .card-header-right {
    //   font-family: electronicFont;
    //   padding-right: 20px;
    //   font-size: 40px;
    //   color: #03d3ec;
    // }

  }

  // .status {
  //   position: absolute;
  //   right: 0.05rem;
  //   line-height: 0.35rem;
  //   height: 0.35rem;
  //   opacity: 0.9;
  //   filter: alpha(opacity=60);
  //   -moz-opacity: 0.6;
  //   display: table-cell;
  //   vertical-align: middle;
  //   z-index: 1;
  // }

  .status {
    position: absolute;
    top: 0.05rem;
    right: 0.05rem;
    line-height: 0.35rem;
    height: 0.35rem;
    opacity: 0.9;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    display: table-cell;
    vertical-align: middle;
    z-index: 1;
  }

  .status-text {
    text-align: center;
    margin: auto;
    color: #fff;

    width: 1.2rem;
    //	padding: 0 5px 0 5px;
    text-align: center;
    font-weight: bold;
    font-size: 0.24rem;
  }









  .status-1 {
    background: #666666;
  }

  .status-0 {
    background: #00e690;
  }

  .status-2 {
    background: #f44;
  }

  .status-3 {
    background: #666666;
  }



  .ring-charts {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/cards.vue